import axios from 'axios';
import { toastBus } from 'src/shared/ui/toast/toastBus';

const BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:4040').replace(/\/$/, '');

const api = axios.create({
    baseURL: `${BASE}/api/v1`,
});

let lastForbiddenAt = 0;
const FORBIDDEN_COOLDOWN_MS = 1200;

function buildRedirectTarget() {
    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        const status = err?.response?.status;
        const msg = err?.response?.data?.error?.message ?? err?.response?.data?.message;

        if (status === 403 && msg === 'LockedUser') {
            if (window.location.pathname !== '/locked') {
                window.location.href = '/locked';
            }
            return new Promise(() => {});
        }

        if (status === 403 && msg === 'MustChangePassword') {
            if (window.location.pathname !== '/change-password') {
                const redirect = encodeURIComponent(buildRedirectTarget());
                window.location.href = `/change-password?redirect=${redirect}`;
            }
            return new Promise(() => {});
        }

        if (status === 403) {
            const now = Date.now();
            if (now - lastForbiddenAt > FORBIDDEN_COOLDOWN_MS) {
                lastForbiddenAt = now;

                const apiErr = err?.response?.data?.error;
                const key = apiErr?.key ? ` (${apiErr.key})` : '';

                const human =
                    msg === 'ForbiddenPermission'
                        ? `권한이 없습니다.${key}`
                        : msg === 'ForbiddenRole'
                          ? '권한이 없습니다. (역할 제한)'
                          : msg === 'Forbidden'
                            ? '권한이 없습니다.'
                            : '권한이 없습니다.';

                toastBus.error(human, { title: '접근 제한' });
            }

            return Promise.reject(err);
        }

        if (status === 401) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('me');
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
            return Promise.reject(err);
        }

        return Promise.reject(err);
    },
);

export default api;
